import { Injectable, Inject } from '@angular/core';
import { ReportingService } from './interfaces/reporting.service';
import { ReportAnfrage, IndustrieReport } from '../../shared/model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SERVICE_URL, REPORTING_PATH } from 'src/environments/tokens';

@Injectable()
export class ReportingHttpService implements ReportingService {
    baseUrl: string;
    reportingPath: string;

    constructor(
        private http: HttpClient,
        @Inject(SERVICE_URL) baseUrl: string,
        @Inject(REPORTING_PATH) reportingPath: string
    ) {
        this.baseUrl = baseUrl;
        this.reportingPath = reportingPath;
    }
  kummulativReportGenerieren(anfrage: any): Observable<any> {
    return this.http.post<any>(
            `${this.baseUrl}${this.reportingPath}kummulativ`,
            anfrage
        );
  }

    reportGenerieren(anfrage: ReportAnfrage): Observable<IndustrieReport> {
        return this.http.post<IndustrieReport>(
            `${this.baseUrl}${this.reportingPath}industrie`,
            anfrage
        );
    }
}
